import { render } from "./Step4.vue?vue&type=template&id=632ec3ac&ts=true"
import script from "./Step4.vue?vue&type=script&lang=ts"
export * from "./Step4.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__